// Reset CSS First.
import "@/assets/scss/reset.scss";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { initAuth } from "./services/UserService";
import BootstrapVue from "bootstrap-vue";
import Repository from "./services/Repository";
import Toasted from "vue-toasted";
import VueTruncate from "vue-truncate-filter";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import VueCarousel from 'vue-carousel';
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

/**
 * Init all social apps.
 */
import socialApps from "./social";
socialApps.init();

/*
 * Start : vue2 Leaflet Global Settings.
 */
import L from "leaflet";
import { Icon } from "leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { getProvider } from "./vue-apollo";

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-marker-cluster", Vue2LeafletMarkercluster);
delete Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "font-awesome/css/font-awesome.css";
import "./assets/scss/custom.scss";

import CKEditor from "@ckeditor/ckeditor5-vue";

Vue.use(CKEditor);

// Initialize authentication.
initAuth(); // This must calling before another authorization-related operations.
window.addEventListener("loginIsExpired", () => {
  router.push("/signin");
});

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Toasted);
Vue.use(Repository);
Vue.use(VueTruncate);
Vue.use(Vuelidate);
Vue.use(PerfectScrollbar);
Vue.use(VueCarousel);

import "./assets/scss/custom.scss"; // Load custom CSS in last order.

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: getProvider(),
  render: (h) => h(App),
}).$mount("#app");
